import React, { useState, useCallback } from 'react';
import { Database, Table, ArrowRight, Check, AlertCircle, RefreshCw, Package, Link2, Eye, Upload, ChevronDown, ChevronRight, Warehouse, Printer, Tag, DollarSign, Users, Phone, MapPin } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import apiService from '../../services/apiService';
import Button from '../../components/ui/Button';
import './MigracionProductosPage.css';

// Campos destino del sistema actual - PRODUCTOS
const CAMPOS_DESTINO = [
  { key: 'nombre', label: 'Nombre', required: true },
  { key: 'descripcion', label: 'Descripcion', required: false },
  { key: 'codigo_corto', label: 'Codigo Corto', required: false },
  { key: 'codigo_barras', label: 'Codigo de Barras', required: false },
  { key: 'precio_compra', label: 'Precio Compra', required: false },
  { key: 'precio_lista', label: 'Precio Lista', required: false },
  { key: 'precio1', label: 'Precio 1 (VTA1)', required: true },
  { key: 'precio2', label: 'Precio 2 (VTA2)', required: false },
  { key: 'precio3', label: 'Precio 3 (VTA3)', required: false },
  { key: 'precio4', label: 'Precio 4 (VTA4)', required: false },
  { key: 'precio5', label: 'Precio 5 (VTA5)', required: false },
  { key: 'precio6', label: 'Precio 6 (VTA6)', required: false },
  { key: 'stock', label: 'Stock', required: false },
  { key: 'stock_minimo', label: 'Stock Minimo', required: false },
  { key: 'unidad_medida', label: 'Unidad de Medida', required: false },
  { key: 'categoria_nombre', label: 'Categoria (nombre)', required: false },
];

// Campos destino del sistema actual - CLIENTES
const CAMPOS_DESTINO_CLIENTES = [
  { key: 'nombre', label: 'Nombre', required: true },
  { key: 'nombre_comercial', label: 'Nombre Comercial', required: false },
  { key: 'telefono', label: 'Telefono Principal', required: false },
  { key: 'telefono2', label: 'Telefono Secundario', required: false },
  { key: 'email', label: 'Email', required: false },
  { key: 'direccion', label: 'Direccion', required: false },
  { key: 'rfc', label: 'RFC', required: false },
  { key: 'monto_credito_maximo', label: 'Limite de Credito', required: false },
  { key: 'dias_credito', label: 'Dias de Credito', required: false },
  { key: 'precio_venta', label: 'Lista de Precios', required: false },
  { key: 'activo', label: 'Estatus (activo)', required: false },
];

const MigracionProductosPage = () => {
  const { showToast, loading, setLoading } = useApp();

  // Tab activo: 'productos' o 'clientes'
  const [activeTab, setActiveTab] = useState('productos');

  // Paso actual del wizard
  const [step, setStep] = useState(1);

  // Paso 1: Datos de conexion
  const [conexion, setConexion] = useState({
    host: 'localhost',
    usuario: 'root',
    password: '',
    base_datos: 'kerigmaaa'
  });
  const [esKerigma, setEsKerigma] = useState(false);
  const [conexionExitosa, setConexionExitosa] = useState(false);

  // Paso 2: Seleccion de tabla
  const [tablas, setTablas] = useState([]);
  const [tablaSeleccionada, setTablaSeleccionada] = useState('');
  const [columnas, setColumnas] = useState([]);

  // Paso 3: Mapeo de campos
  const [mapeo, setMapeo] = useState({});

  // Paso 4: Vista previa y migracion
  const [preview, setPreview] = useState([]);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [totalUnidades, setTotalUnidades] = useState(0);
  const [registrosMigrados, setRegistrosMigrados] = useState(0);
  const [equivalenciasCreadas, setEquivalenciasCreadas] = useState(0);
  const [almacenesMigrados, setAlmacenesMigrados] = useState(0);
  const [categoriasCreadas, setCategoriasCreadas] = useState(0);
  const [descuentosMigrados, setDescuentosMigrados] = useState(0);
  const [omitidos, setOmitidos] = useState(0);
  const [migracionCompleta, setMigracionCompleta] = useState(false);
  const [erroresMigracion, setErroresMigracion] = useState([]);

  // Info adicional de Kerigma
  const [infoKerigma, setInfoKerigma] = useState({
    areasDisponibles: 0,
    productosConArea: 0,
    listasPrecios: 0,
    descuentosVolumen: 0
  });

  // Expandir/contraer preview
  const [previewExpandido, setPreviewExpandido] = useState(true);

  // ============ ESTADOS PARA MIGRACION DE CLIENTES ============
  const [stepClientes, setStepClientes] = useState(1);
  const [previewClientes, setPreviewClientes] = useState([]);
  const [totalClientes, setTotalClientes] = useState(0);
  const [clientesMigrados, setClientesMigrados] = useState(0);
  const [telefonosMigrados, setTelefonosMigrados] = useState(0);
  const [direccionesMigradas, setDireccionesMigradas] = useState(0);
  const [datosFiscalesMigrados, setDatosFiscalesMigrados] = useState(0);
  const [clientesOmitidos, setClientesOmitidos] = useState(0);
  const [migracionClientesCompleta, setMigracionClientesCompleta] = useState(false);
  const [erroresMigracionClientes, setErroresMigracionClientes] = useState([]);
  const [previewClientesExpandido, setPreviewClientesExpandido] = useState(true);

  // ============ ESTADOS PARA DIFERENCIA DE COSTOS ============
  const [stepCostos, setStepCostos] = useState(1);
  const [previewCostos, setPreviewCostos] = useState([]);
  const [totalCostos, setTotalCostos] = useState(0);
  const [costosActualizados, setCostosActualizados] = useState(0);
  const [costosNoEncontrados, setCostosNoEncontrados] = useState(0);
  const [migracionCostosCompleta, setMigracionCostosCompleta] = useState(false);
  const [erroresCostos, setErroresCostos] = useState([]);
  const [previewCostosExpandido, setPreviewCostosExpandido] = useState(true);

  // Handler para cambios en conexion
  const handleConexionChange = (field, value) => {
    setConexion(prev => ({ ...prev, [field]: value }));
    setConexionExitosa(false);
  };

  // Probar conexion
  const probarConexion = async () => {
    if (!conexion.host || !conexion.usuario || !conexion.base_datos) {
      showToast('Complete todos los campos de conexion', 'warning');
      return;
    }

    try {
      setLoading(true);
      const result = await apiService.probarConexionExterna(conexion);

      if (result.success) {
        setConexionExitosa(true);
        setTablas(result.data.tablas || []);

        // Detectar si es base de datos Kerigma
        const tablasKerigma = ['tblcatarticulos', 'tblundcospreart', 'tblcatagrupacionart'];
        const nombresTablas = (result.data.tablas || []).map(t => t.name.toLowerCase());
        const detectadoKerigma = tablasKerigma.every(t => nombresTablas.includes(t));
        setEsKerigma(detectadoKerigma);

        if (detectadoKerigma) {
          showToast('Conexion exitosa - Sistema Kerigma detectado', 'success');
        } else {
          showToast('Conexion exitosa', 'success');
        }
      } else {
        setConexionExitosa(false);
        showToast(result.message || 'Error al conectar', 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      showToast('Error al probar conexion', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Seleccionar tabla y obtener columnas
  const seleccionarTabla = async (tabla) => {
    setTablaSeleccionada(tabla);

    try {
      setLoading(true);
      const result = await apiService.obtenerColumnasTabla({
        ...conexion,
        tabla
      });

      if (result.success) {
        setColumnas(result.data.columnas || []);
        // Intentar auto-mapear campos por nombre similar
        autoMapearCampos(result.data.columnas || []);
      } else {
        showToast(result.message || 'Error al obtener columnas', 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      showToast('Error al obtener columnas', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Auto-mapear campos por nombre similar
  const autoMapearCampos = useCallback((cols) => {
    const nuevoMapeo = {};
    const nombresColumnas = cols.map(c => c.name.toLowerCase());

    CAMPOS_DESTINO.forEach(campo => {
      const key = campo.key.toLowerCase();

      // Buscar coincidencia exacta
      let match = nombresColumnas.find(n => n === key);

      // Buscar coincidencia parcial
      if (!match) {
        if (key === 'nombre') {
          match = nombresColumnas.find(n => n.includes('nombre') || n.includes('name') || n.includes('descripcion'));
        } else if (key === 'codigo_corto') {
          match = nombresColumnas.find(n => n.includes('codigo') || n.includes('code') || n.includes('sku'));
        } else if (key === 'codigo_barras') {
          match = nombresColumnas.find(n => n.includes('barras') || n.includes('barcode') || n.includes('ean') || n.includes('upc'));
        } else if (key === 'precio1' || key === 'precio_compra') {
          match = nombresColumnas.find(n => n.includes('precio') || n.includes('price') || n.includes('costo'));
        } else if (key === 'stock') {
          match = nombresColumnas.find(n => n.includes('stock') || n.includes('existencia') || n.includes('cantidad') || n.includes('inventory'));
        } else if (key === 'categoria_nombre') {
          match = nombresColumnas.find(n => n.includes('categoria') || n.includes('category') || n.includes('tipo'));
        }
      }

      if (match) {
        const columnaOriginal = cols.find(c => c.name.toLowerCase() === match);
        if (columnaOriginal) {
          nuevoMapeo[campo.key] = columnaOriginal.name;
        }
      }
    });

    setMapeo(nuevoMapeo);
  }, []);

  // Cambiar mapeo de campo
  const handleMapeoChange = (campoDestino, columnaOrigen) => {
    setMapeo(prev => ({
      ...prev,
      [campoDestino]: columnaOrigen
    }));
  };

  // Validar mapeo minimo requerido
  const validarMapeo = () => {
    const camposRequeridos = CAMPOS_DESTINO.filter(c => c.required);
    const faltantes = camposRequeridos.filter(c => !mapeo[c.key]);

    if (faltantes.length > 0) {
      showToast(`Campos requeridos sin mapear: ${faltantes.map(f => f.label).join(', ')}`, 'warning');
      return false;
    }
    return true;
  };

  // Obtener preview de datos
  const obtenerPreview = async () => {
    if (!validarMapeo()) return;

    try {
      setLoading(true);
      const result = await apiService.previewMigracion({
        ...conexion,
        tabla: tablaSeleccionada,
        mapeo,
        limite: 10
      });

      if (result.success) {
        setPreview(result.data.preview || []);
        setTotalRegistros(result.data.total || 0);
        setStep(4);
      } else {
        showToast(result.message || 'Error al obtener preview', 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      showToast('Error al obtener preview', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Ejecutar migracion
  const ejecutarMigracion = async () => {
    try {
      setLoading(true);
      setRegistrosMigrados(0);
      setErroresMigracion([]);

      const result = await apiService.ejecutarMigracionProductos({
        ...conexion,
        tabla: tablaSeleccionada,
        mapeo
      });

      if (result.success) {
        setRegistrosMigrados(result.data.migrados || 0);
        setErroresMigracion(result.data.errores || []);
        setMigracionCompleta(true);
        showToast(`Migracion completada: ${result.data.migrados} productos migrados`, 'success');
      } else {
        showToast(result.message || 'Error en la migracion', 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      showToast('Error al ejecutar migracion', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Reiniciar proceso productos
  const reiniciar = () => {
    setStep(1);
    setEsKerigma(false);
    setConexionExitosa(false);
    setTablas([]);
    setTablaSeleccionada('');
    setColumnas([]);
    setMapeo({});
    setPreview([]);
    setTotalRegistros(0);
    setTotalUnidades(0);
    setRegistrosMigrados(0);
    setEquivalenciasCreadas(0);
    setAlmacenesMigrados(0);
    setCategoriasCreadas(0);
    setDescuentosMigrados(0);
    setOmitidos(0);
    setMigracionCompleta(false);
    setErroresMigracion([]);
    setInfoKerigma({ areasDisponibles: 0, productosConArea: 0, listasPrecios: 0, descuentosVolumen: 0 });
  };

  // Reiniciar proceso clientes
  const reiniciarClientes = () => {
    setStepClientes(1);
    setPreviewClientes([]);
    setTotalClientes(0);
    setClientesMigrados(0);
    setTelefonosMigrados(0);
    setDireccionesMigradas(0);
    setClientesOmitidos(0);
    setMigracionClientesCompleta(false);
    setErroresMigracionClientes([]);
  };

  // Cargar preview de clientes Kerigma
  const cargarPreviewClientes = async () => {
    try {
      setLoading(true);
      const result = await apiService.previewMigracionClientesKerigma({
        ...conexion,
        limite: 20
      });

      if (result.success) {
        setPreviewClientes(result.data.preview || []);
        setTotalClientes(result.data.total || 0);
        setStepClientes(2);
      } else {
        showToast(result.message || 'Error al obtener preview de clientes', 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      showToast('Error al obtener preview de clientes', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Ejecutar migración de clientes Kerigma
  const ejecutarMigracionClientes = async () => {
    try {
      setLoading(true);
      setClientesMigrados(0);
      setErroresMigracionClientes([]);

      const result = await apiService.ejecutarMigracionClientesKerigma(conexion);

      if (result.success) {
        setClientesMigrados(result.data.clientesMigrados || 0);
        setTelefonosMigrados(result.data.telefonosMigrados || 0);
        setDireccionesMigradas(result.data.direccionesMigradas || 0);
        setDatosFiscalesMigrados(result.data.datosFiscalesMigrados || 0);
        setClientesOmitidos(result.data.omitidos || 0);
        setErroresMigracionClientes(result.data.errores || []);
        setMigracionClientesCompleta(true);
        showToast(`Migracion completada: ${result.data.clientesMigrados} clientes migrados`, 'success');
      } else {
        showToast(result.message || 'Error en la migracion de clientes', 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      showToast('Error al ejecutar migracion de clientes', 'error');
    } finally {
      setLoading(false);
    }
  };

  // ============ FUNCIONES PARA DIFERENCIA DE COSTOS ============

  // Reiniciar proceso costos
  const reiniciarCostos = () => {
    setStepCostos(1);
    setPreviewCostos([]);
    setTotalCostos(0);
    setCostosActualizados(0);
    setCostosNoEncontrados(0);
    setMigracionCostosCompleta(false);
    setErroresCostos([]);
  };

  // Cargar preview de diferencia de costos (BD local)
  const cargarPreviewCostos = async () => {
    try {
      setLoading(true);
      const result = await apiService.previewDiferenciaCostos({ limite: 20 });

      if (result.success) {
        setPreviewCostos(result.data.preview || []);
        setTotalCostos(result.data.total || 0);
        setStepCostos(2);
      } else {
        showToast(result.message || 'Error al obtener preview de costos', 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      showToast('Error al obtener preview de costos', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Ejecutar actualización de costos (BD local)
  const ejecutarActualizacionCostos = async () => {
    try {
      setLoading(true);
      setCostosActualizados(0);
      setErroresCostos([]);

      const result = await apiService.ejecutarActualizacionCostos({});

      if (result.success) {
        setCostosActualizados(result.data.actualizados || 0);
        setCostosNoEncontrados(result.data.noEncontrados || 0);
        setErroresCostos(result.data.errores || []);
        setMigracionCostosCompleta(true);
        showToast(`Actualización completada: ${result.data.actualizados} productos actualizados`, 'success');
      } else {
        showToast(result.message || 'Error en la actualización de costos', 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      showToast('Error al ejecutar actualización de costos', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="migracion-page">
      <div className="migracion-header">
        <div className="header-title">
          <Database size={28} />
          <div>
            <h1>Migracion de Datos</h1>
            <p>Importar datos desde base de datos externa</p>
          </div>
        </div>
      </div>

      {/* Tabs de navegación */}
      <div className="migracion-tabs">
        <button
          className={`migracion-tab ${activeTab === 'productos' ? 'active' : ''}`}
          onClick={() => setActiveTab('productos')}
        >
          <Package size={18} />
          Productos
        </button>
        <button
          className={`migracion-tab ${activeTab === 'clientes' ? 'active' : ''}`}
          onClick={() => setActiveTab('clientes')}
        >
          <Users size={18} />
          Clientes
        </button>
        <button
          className={`migracion-tab ${activeTab === 'costos' ? 'active' : ''}`}
          onClick={() => setActiveTab('costos')}
        >
          <DollarSign size={18} />
          Costos
        </button>
      </div>

      {/* ============ TAB PRODUCTOS ============ */}
      {activeTab === 'productos' && (
        <>
      {/* Progress Steps */}
      <div className="migracion-steps">
        <div className={`step ${step >= 1 ? 'active' : ''} ${step > 1 ? 'completed' : ''}`}>
          <div className="step-number">{step > 1 ? <Check size={16} /> : '1'}</div>
          <span>Conexion</span>
        </div>
        <div className="step-line" />
        {!esKerigma ? (
          <>
            <div className={`step ${step >= 2 ? 'active' : ''} ${step > 2 ? 'completed' : ''}`}>
              <div className="step-number">{step > 2 ? <Check size={16} /> : '2'}</div>
              <span>Tabla</span>
            </div>
            <div className="step-line" />
            <div className={`step ${step >= 3 ? 'active' : ''} ${step > 3 ? 'completed' : ''}`}>
              <div className="step-number">{step > 3 ? <Check size={16} /> : '3'}</div>
              <span>Mapeo</span>
            </div>
            <div className="step-line" />
            <div className={`step ${step >= 4 ? 'active' : ''} ${migracionCompleta ? 'completed' : ''}`}>
              <div className="step-number">{migracionCompleta ? <Check size={16} /> : '4'}</div>
              <span>Migrar</span>
            </div>
          </>
        ) : (
          <>
            <div className={`step ${step >= 2 ? 'active' : ''} ${migracionCompleta ? 'completed' : ''}`}>
              <div className="step-number">{migracionCompleta ? <Check size={16} /> : '2'}</div>
              <span>Migrar</span>
            </div>
          </>
        )}
      </div>

      <div className="migracion-content">
        {/* Step 1: Conexion */}
        {step === 1 && (
          <div className="step-content">
            <h2><Database size={20} /> Datos de Conexion</h2>
            <p className="step-description">
              Ingrese los datos de conexion a la base de datos MySQL del sistema anterior.
            </p>

            <div className="conexion-form">
              <div className="form-row">
                <div className="form-group">
                  <label>Host / Servidor</label>
                  <input
                    type="text"
                    value={conexion.host}
                    onChange={(e) => handleConexionChange('host', e.target.value)}
                    placeholder="localhost o IP del servidor"
                  />
                </div>
                <div className="form-group">
                  <label>Base de Datos</label>
                  <input
                    type="text"
                    value={conexion.base_datos}
                    onChange={(e) => handleConexionChange('base_datos', e.target.value)}
                    placeholder="Nombre de la base de datos"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Usuario</label>
                  <input
                    type="text"
                    value={conexion.usuario}
                    onChange={(e) => handleConexionChange('usuario', e.target.value)}
                    placeholder="Usuario de MySQL"
                  />
                </div>
                <div className="form-group">
                  <label>Contrasena</label>
                  <input
                    type="password"
                    value={conexion.password}
                    onChange={(e) => handleConexionChange('password', e.target.value)}
                    placeholder="Contrasena (puede estar vacia)"
                  />
                </div>
              </div>

              <div className="conexion-actions">
                <Button
                  variant="primary"
                  onClick={probarConexion}
                  disabled={loading}
                >
                  {loading ? <RefreshCw size={16} className="spin" /> : <Database size={16} />}
                  Probar Conexion
                </Button>

                {conexionExitosa && (
                  <div className="conexion-exito">
                    <Check size={18} />
                    Conexion exitosa - {tablas.length} tablas encontradas
                    {esKerigma && <span style={{ marginLeft: '0.5rem', color: '#059669', fontWeight: 'bold' }}>| Sistema Kerigma detectado</span>}
                  </div>
                )}
              </div>

              {esKerigma && conexionExitosa && (
                <div style={{
                  marginTop: '1rem',
                  padding: '1rem',
                  background: '#ecfdf5',
                  borderRadius: '0.5rem',
                  border: '1px solid #a7f3d0'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                    <Check size={18} color="#059669" />
                    <strong style={{ color: '#065f46' }}>Sistema Kerigma Detectado</strong>
                  </div>
                  <p style={{ margin: 0, fontSize: '0.875rem', color: '#047857' }}>
                    Se utilizara el mapeo automatico optimizado para Kerigma.
                  </p>
                  <div style={{ marginTop: '0.75rem', display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.5rem', fontSize: '0.875rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#065f46' }}>
                      <DollarSign size={14} /> 7 listas de precios (VTA1-VTA6)
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#065f46' }}>
                      <Warehouse size={14} /> Areas como almacenes
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#065f46' }}>
                      <Printer size={14} /> Impresoras por producto
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#065f46' }}>
                      <Tag size={14} /> Categorias filtradas
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="step-actions">
              <div />
              <Button
                variant="primary"
                onClick={() => setStep(2)}
                disabled={!conexionExitosa}
              >
                {esKerigma ? 'Continuar con Kerigma' : 'Siguiente'}
                <ArrowRight size={16} />
              </Button>
            </div>
          </div>
        )}

        {/* Step 2: Seleccion de Tabla (no Kerigma) o Preview/Migrar (Kerigma) */}
        {step === 2 && !esKerigma && (
          <div className="step-content">
            <h2><Table size={20} /> Seleccionar Tabla de Productos</h2>
            <p className="step-description">
              Seleccione la tabla que contiene los productos a migrar.
            </p>

            <div className="tablas-grid">
              {tablas.map((tabla) => (
                <div
                  key={tabla.name}
                  className={`tabla-card ${tablaSeleccionada === tabla.name ? 'selected' : ''}`}
                  onClick={() => seleccionarTabla(tabla.name)}
                >
                  <Table size={20} />
                  <span className="tabla-nombre">{tabla.name}</span>
                  <span className="tabla-registros">{tabla.rows} registros</span>
                </div>
              ))}
            </div>

            {tablaSeleccionada && columnas.length > 0 && (
              <div className="columnas-preview">
                <h4>Columnas de la tabla "{tablaSeleccionada}":</h4>
                <div className="columnas-list">
                  {columnas.map((col) => (
                    <span key={col.name} className="columna-badge">
                      {col.name}
                      <small>{col.type}</small>
                    </span>
                  ))}
                </div>
              </div>
            )}

            <div className="step-actions">
              <Button variant="secondary" onClick={() => setStep(1)}>
                Anterior
              </Button>
              <Button
                variant="primary"
                onClick={() => setStep(3)}
                disabled={!tablaSeleccionada || columnas.length === 0}
              >
                Siguiente
                <ArrowRight size={16} />
              </Button>
            </div>
          </div>
        )}

        {/* Step 2 Kerigma: Preview y Migracion directa */}
        {step === 2 && esKerigma && (
          <div className="step-content">
            <h2><Upload size={20} /> Migracion desde Kerigma</h2>

            {!migracionCompleta ? (
              <>
                <div className="migracion-info" style={{ background: '#dbeafe' }}>
                  <Database size={18} />
                  <span>
                    Se migraran los productos desde <strong>tblcatarticulos</strong> con precios de <strong>tblprecios</strong> (7 listas)
                  </span>
                </div>

                {/* Cargar preview automaticamente */}
                {preview.length === 0 && !loading && (
                  <div style={{ textAlign: 'center', padding: '2rem' }}>
                    <Button
                      variant="primary"
                      onClick={async () => {
                        try {
                          setLoading(true);
                          const result = await apiService.previewMigracionKerigma({
                            ...conexion,
                            limite: 20
                          });
                          if (result.success) {
                            setPreview(result.data.preview || []);
                            setTotalRegistros(result.data.total || 0);
                            setTotalUnidades(result.data.totalUnidades || 0);
                            setInfoKerigma({
                              areasDisponibles: result.data.areasDisponibles || 0,
                              productosConArea: result.data.productosConArea || 0,
                              listasPrecios: result.data.listasPrecios || 0,
                              descuentosVolumen: result.data.descuentosVolumen || 0
                            });
                          } else {
                            showToast(result.message || 'Error al obtener preview', 'error');
                          }
                        } catch (error) {
                          showToast('Error al obtener preview', 'error');
                        } finally {
                          setLoading(false);
                        }
                      }}
                      disabled={loading}
                    >
                      {loading ? <RefreshCw size={16} className="spin" /> : <Eye size={16} />}
                      Cargar Vista Previa
                    </Button>
                  </div>
                )}

                {preview.length > 0 && (
                  <>
                    {/* Estadísticas de la migración */}
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                      gap: '1rem',
                      margin: '1rem 0',
                      padding: '1rem',
                      background: '#f8fafc',
                      borderRadius: '0.5rem'
                    }}>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#3b82f6' }}>{totalRegistros}</div>
                        <div style={{ fontSize: '0.75rem', color: '#64748b' }}>Productos base</div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#8b5cf6' }}>{totalUnidades}</div>
                        <div style={{ fontSize: '0.75rem', color: '#64748b' }}>Unidades totales</div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#10b981' }}>{infoKerigma.areasDisponibles}</div>
                        <div style={{ fontSize: '0.75rem', color: '#64748b' }}>Areas/Almacenes</div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#f59e0b' }}>{infoKerigma.productosConArea}</div>
                        <div style={{ fontSize: '0.75rem', color: '#64748b' }}>Productos con area</div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#ec4899' }}>{infoKerigma.listasPrecios}</div>
                        <div style={{ fontSize: '0.75rem', color: '#64748b' }}>Listas de precios</div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#14b8a6' }}>{infoKerigma.descuentosVolumen}</div>
                        <div style={{ fontSize: '0.75rem', color: '#64748b' }}>Descuentos vol.</div>
                      </div>
                    </div>

                    <div className="preview-section">
                      <div
                        className="preview-header"
                        onClick={() => setPreviewExpandido(!previewExpandido)}
                      >
                        {previewExpandido ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
                        <span>Vista previa (primeros 20 registros)</span>
                      </div>

                      {previewExpandido && (
                        <div className="preview-table-wrapper">
                          <table className="preview-table">
                            <thead>
                              <tr>
                                <th>Codigo</th>
                                <th>Nombre</th>
                                <th>Precio</th>
                                <th>Costo</th>
                                <th>Stock</th>
                                <th>Unidad</th>
                                <th>Categoria</th>
                                <th>Almacen</th>
                              </tr>
                            </thead>
                            <tbody>
                              {preview.map((row, idx) => (
                                <tr key={idx}>
                                  <td>{row.codigo}</td>
                                  <td>{row.nombre?.substring(0, 35)}</td>
                                  <td>${parseFloat(row.precio || 0).toFixed(2)}</td>
                                  <td>${parseFloat(row.costo || 0).toFixed(2)}</td>
                                  <td>{parseFloat(row.stock || 0).toFixed(0)}</td>
                                  <td>{row.unidad}</td>
                                  <td>{row.categoria?.substring(0, 15) || '-'}</td>
                                  <td>{row.almacen?.substring(0, 12) || '-'}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </>
                )}

                <div className="step-actions">
                  <Button variant="secondary" onClick={() => { setStep(1); setPreview([]); }}>
                    Anterior
                  </Button>
                  <Button
                    variant="success"
                    onClick={async () => {
                      try {
                        setLoading(true);
                        setRegistrosMigrados(0);
                        setErroresMigracion([]);

                        const result = await apiService.ejecutarMigracionKerigma(conexion);

                        if (result.success) {
                          setRegistrosMigrados(result.data.migrados || 0);
                          setEquivalenciasCreadas(result.data.equivalencias || 0);
                          setAlmacenesMigrados(result.data.almacenes || 0);
                          setCategoriasCreadas(result.data.categorias || 0);
                          setDescuentosMigrados(result.data.descuentos || 0);
                          setOmitidos(result.data.omitidos || 0);
                          setErroresMigracion(result.data.errores || []);
                          setMigracionCompleta(true);
                          const msg = `Migracion completada: ${result.data.migrados} productos`;
                          showToast(msg, 'success');
                        } else {
                          showToast(result.message || 'Error en la migracion', 'error');
                        }
                      } catch (error) {
                        showToast('Error al ejecutar migracion', 'error');
                      } finally {
                        setLoading(false);
                      }
                    }}
                    disabled={loading || preview.length === 0}
                  >
                    {loading ? (
                      <>
                        <RefreshCw size={16} className="spin" />
                        Migrando...
                      </>
                    ) : (
                      <>
                        <Upload size={16} />
                        Ejecutar Migracion Kerigma
                      </>
                    )}
                  </Button>
                </div>
              </>
            ) : (
              <div className="migracion-resultado">
                <div className="resultado-exito">
                  <Check size={48} />
                  <h3>Migracion Kerigma Completada</h3>
                  <div className="resultado-stats" style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
                    gap: '1rem',
                    marginTop: '1rem'
                  }}>
                    <div style={{ textAlign: 'center', padding: '0.5rem', background: '#f0fdf4', borderRadius: '0.5rem' }}>
                      <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#16a34a' }}>{registrosMigrados}</div>
                      <div style={{ fontSize: '0.75rem', color: '#15803d' }}>Productos</div>
                    </div>
                    <div style={{ textAlign: 'center', padding: '0.5rem', background: '#eff6ff', borderRadius: '0.5rem' }}>
                      <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#2563eb' }}>{equivalenciasCreadas}</div>
                      <div style={{ fontSize: '0.75rem', color: '#1d4ed8' }}>Equivalencias</div>
                    </div>
                    <div style={{ textAlign: 'center', padding: '0.5rem', background: '#faf5ff', borderRadius: '0.5rem' }}>
                      <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#9333ea' }}>{almacenesMigrados}</div>
                      <div style={{ fontSize: '0.75rem', color: '#7e22ce' }}>Almacenes</div>
                    </div>
                    <div style={{ textAlign: 'center', padding: '0.5rem', background: '#fefce8', borderRadius: '0.5rem' }}>
                      <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#ca8a04' }}>{categoriasCreadas}</div>
                      <div style={{ fontSize: '0.75rem', color: '#a16207' }}>Categorias</div>
                    </div>
                    <div style={{ textAlign: 'center', padding: '0.5rem', background: '#fdf2f8', borderRadius: '0.5rem' }}>
                      <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#db2777' }}>{descuentosMigrados}</div>
                      <div style={{ fontSize: '0.75rem', color: '#be185d' }}>Descuentos Vol.</div>
                    </div>
                    {omitidos > 0 && (
                      <div style={{ textAlign: 'center', padding: '0.5rem', background: '#fef2f2', borderRadius: '0.5rem' }}>
                        <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#dc2626' }}>{omitidos}</div>
                        <div style={{ fontSize: '0.75rem', color: '#b91c1c' }}>Omitidos</div>
                      </div>
                    )}
                  </div>
                </div>

                {erroresMigracion.length > 0 && (
                  <div className="errores-lista">
                    <h4><AlertCircle size={16} /> Errores durante la migracion ({erroresMigracion.length})</h4>
                    <ul>
                      {erroresMigracion.slice(0, 10).map((error, idx) => (
                        <li key={idx}>{error}</li>
                      ))}
                      {erroresMigracion.length > 10 && (
                        <li className="more">... y {erroresMigracion.length - 10} errores mas</li>
                      )}
                    </ul>
                  </div>
                )}

                <div className="step-actions center">
                  <Button variant="primary" onClick={reiniciar}>
                    <RefreshCw size={16} />
                    Nueva Migracion
                  </Button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Step 3: Mapeo de Campos */}
        {step === 3 && (
          <div className="step-content">
            <h2><Link2 size={20} /> Mapeo de Campos</h2>
            <p className="step-description">
              Asocie los campos de la tabla origen con los campos del sistema.
              Los campos marcados con * son requeridos.
            </p>

            <div className="mapeo-container">
              <div className="mapeo-header">
                <span>Campo Destino</span>
                <span></span>
                <span>Campo Origen</span>
              </div>

              {CAMPOS_DESTINO.map((campo) => (
                <div key={campo.key} className={`mapeo-row ${campo.required ? 'required' : ''}`}>
                  <div className="campo-destino">
                    <Package size={14} />
                    {campo.label}
                    {campo.required && <span className="required-mark">*</span>}
                  </div>
                  <div className="mapeo-arrow">
                    <ArrowRight size={16} />
                  </div>
                  <div className="campo-origen">
                    <select
                      value={mapeo[campo.key] || ''}
                      onChange={(e) => handleMapeoChange(campo.key, e.target.value)}
                    >
                      <option value="">-- No mapear --</option>
                      {columnas.map((col) => (
                        <option key={col.name} value={col.name}>
                          {col.name} ({col.type})
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              ))}
            </div>

            <div className="step-actions">
              <Button variant="secondary" onClick={() => setStep(2)}>
                Anterior
              </Button>
              <Button
                variant="primary"
                onClick={obtenerPreview}
                disabled={loading}
              >
                {loading ? <RefreshCw size={16} className="spin" /> : <Eye size={16} />}
                Ver Preview
              </Button>
            </div>
          </div>
        )}

        {/* Step 4: Preview y Migracion */}
        {step === 4 && (
          <div className="step-content">
            <h2><Upload size={20} /> Vista Previa y Migracion</h2>

            {!migracionCompleta ? (
              <>
                <div className="migracion-info">
                  <AlertCircle size={18} />
                  <span>
                    Se migraran <strong>{totalRegistros}</strong> productos de la tabla "{tablaSeleccionada}"
                  </span>
                </div>

                {/* Preview colapsable */}
                <div className="preview-section">
                  <div
                    className="preview-header"
                    onClick={() => setPreviewExpandido(!previewExpandido)}
                  >
                    {previewExpandido ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
                    <span>Vista previa (primeros 10 registros)</span>
                  </div>

                  {previewExpandido && (
                    <div className="preview-table-wrapper">
                      <table className="preview-table">
                        <thead>
                          <tr>
                            {CAMPOS_DESTINO.filter(c => mapeo[c.key]).map((campo) => (
                              <th key={campo.key}>{campo.label}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {preview.map((row, idx) => (
                            <tr key={idx}>
                              {CAMPOS_DESTINO.filter(c => mapeo[c.key]).map((campo) => (
                                <td key={campo.key}>
                                  {row[campo.key] !== null && row[campo.key] !== undefined
                                    ? String(row[campo.key]).substring(0, 50)
                                    : '-'}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                <div className="step-actions">
                  <Button variant="secondary" onClick={() => setStep(3)}>
                    Anterior
                  </Button>
                  <Button
                    variant="success"
                    onClick={ejecutarMigracion}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <RefreshCw size={16} className="spin" />
                        Migrando...
                      </>
                    ) : (
                      <>
                        <Upload size={16} />
                        Ejecutar Migracion
                      </>
                    )}
                  </Button>
                </div>
              </>
            ) : (
              <div className="migracion-resultado">
                <div className="resultado-exito">
                  <Check size={48} />
                  <h3>Migracion Completada</h3>
                  <p>Se han migrado <strong>{registrosMigrados}</strong> productos exitosamente.</p>
                </div>

                {erroresMigracion.length > 0 && (
                  <div className="errores-lista">
                    <h4><AlertCircle size={16} /> Errores durante la migracion ({erroresMigracion.length})</h4>
                    <ul>
                      {erroresMigracion.slice(0, 10).map((error, idx) => (
                        <li key={idx}>{error}</li>
                      ))}
                      {erroresMigracion.length > 10 && (
                        <li className="more">... y {erroresMigracion.length - 10} errores mas</li>
                      )}
                    </ul>
                  </div>
                )}

                <div className="step-actions center">
                  <Button variant="primary" onClick={reiniciar}>
                    <RefreshCw size={16} />
                    Nueva Migracion
                  </Button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
        </>
      )}

      {/* ============ TAB CLIENTES ============ */}
      {activeTab === 'clientes' && (
        <>
          {/* Progress Steps Clientes */}
          <div className="migracion-steps">
            <div className={`step ${stepClientes >= 1 ? 'active' : ''} ${stepClientes > 1 ? 'completed' : ''}`}>
              <div className="step-number">{stepClientes > 1 ? <Check size={16} /> : '1'}</div>
              <span>Conexion</span>
            </div>
            <div className="step-line" />
            <div className={`step ${stepClientes >= 2 ? 'active' : ''} ${migracionClientesCompleta ? 'completed' : ''}`}>
              <div className="step-number">{migracionClientesCompleta ? <Check size={16} /> : '2'}</div>
              <span>Migrar</span>
            </div>
          </div>

          <div className="migracion-content">
            {/* Step 1: Conexion (reutiliza la misma conexion) */}
            {stepClientes === 1 && (
              <div className="step-content">
                <h2><Database size={20} /> Conexion a Kerigma</h2>
                <p className="step-description">
                  Conectese a la base de datos Kerigma para migrar clientes.
                </p>

                {!conexionExitosa ? (
                  <>
                    <div className="conexion-form">
                      <div className="form-row">
                        <div className="form-group">
                          <label>Host / Servidor</label>
                          <input
                            type="text"
                            value={conexion.host}
                            onChange={(e) => handleConexionChange('host', e.target.value)}
                            placeholder="localhost o IP del servidor"
                          />
                        </div>
                        <div className="form-group">
                          <label>Base de Datos</label>
                          <input
                            type="text"
                            value={conexion.base_datos}
                            onChange={(e) => handleConexionChange('base_datos', e.target.value)}
                            placeholder="Nombre de la base de datos"
                          />
                        </div>
                      </div>

                      <div className="form-row">
                        <div className="form-group">
                          <label>Usuario</label>
                          <input
                            type="text"
                            value={conexion.usuario}
                            onChange={(e) => handleConexionChange('usuario', e.target.value)}
                            placeholder="Usuario de MySQL"
                          />
                        </div>
                        <div className="form-group">
                          <label>Contrasena</label>
                          <input
                            type="password"
                            value={conexion.password}
                            onChange={(e) => handleConexionChange('password', e.target.value)}
                            placeholder="Contrasena (puede estar vacia)"
                          />
                        </div>
                      </div>

                      <div className="conexion-actions">
                        <Button
                          variant="primary"
                          onClick={probarConexion}
                          disabled={loading}
                        >
                          {loading ? <RefreshCw size={16} className="spin" /> : <Database size={16} />}
                          Probar Conexion
                        </Button>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="conexion-exito" style={{ marginBottom: '1rem' }}>
                      <Check size={18} />
                      Conexion exitosa a <strong>{conexion.base_datos}</strong>
                    </div>

                    <div style={{
                      padding: '1rem',
                      background: '#ecfdf5',
                      borderRadius: '0.5rem',
                      border: '1px solid #a7f3d0',
                      marginBottom: '1rem'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                        <Users size={18} color="#059669" />
                        <strong style={{ color: '#065f46' }}>Migracion de Clientes Kerigma</strong>
                      </div>
                      <p style={{ margin: 0, fontSize: '0.875rem', color: '#047857' }}>
                        Se migraran los clientes desde <strong>tblcatclientes</strong> con sus telefonos y direcciones.
                      </p>
                      <div style={{ marginTop: '0.75rem', display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.5rem', fontSize: '0.875rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#065f46' }}>
                          <Phone size={14} /> Telefonos (TEL1, TEL2)
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#065f46' }}>
                          <MapPin size={14} /> Direcciones completas
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#065f46' }}>
                          <DollarSign size={14} /> Limites de credito
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#065f46' }}>
                          <Tag size={14} /> Listas de precios
                        </div>
                      </div>
                    </div>

                    <div className="step-actions">
                      <div />
                      <Button
                        variant="primary"
                        onClick={cargarPreviewClientes}
                        disabled={loading}
                      >
                        {loading ? <RefreshCw size={16} className="spin" /> : <Eye size={16} />}
                        Cargar Vista Previa
                      </Button>
                    </div>
                  </>
                )}
              </div>
            )}

            {/* Step 2: Preview y Migracion */}
            {stepClientes === 2 && (
              <div className="step-content">
                <h2><Upload size={20} /> Migracion de Clientes</h2>

                {!migracionClientesCompleta ? (
                  <>
                    <div className="migracion-info" style={{ background: '#dbeafe' }}>
                      <Users size={18} />
                      <span>
                        Se migraran <strong>{totalClientes}</strong> clientes desde <strong>tblcatclientes</strong>
                      </span>
                    </div>

                    {/* Estadísticas */}
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                      gap: '1rem',
                      margin: '1rem 0',
                      padding: '1rem',
                      background: '#f8fafc',
                      borderRadius: '0.5rem'
                    }}>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#3b82f6' }}>{totalClientes}</div>
                        <div style={{ fontSize: '0.75rem', color: '#64748b' }}>Clientes totales</div>
                      </div>
                    </div>

                    {/* Preview colapsable */}
                    <div className="preview-section">
                      <div
                        className="preview-header"
                        onClick={() => setPreviewClientesExpandido(!previewClientesExpandido)}
                      >
                        {previewClientesExpandido ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
                        <span>Vista previa (primeros 20 registros)</span>
                      </div>

                      {previewClientesExpandido && (
                        <div className="preview-table-wrapper">
                          <table className="preview-table">
                            <thead>
                              <tr>
                                <th>Codigo</th>
                                <th>Nombre</th>
                                <th>Telefono</th>
                                <th>RFC</th>
                                <th>Credito</th>
                                <th>Lista</th>
                                <th>Estatus</th>
                              </tr>
                            </thead>
                            <tbody>
                              {previewClientes.map((row, idx) => (
                                <tr key={idx}>
                                  <td>{row.codigo}</td>
                                  <td>{row.nombre?.substring(0, 30)}</td>
                                  <td>{row.telefono1 || row.telefono2 || '-'}</td>
                                  <td>{row.rfc || '-'}</td>
                                  <td>${parseFloat(row.limite_credito || 0).toLocaleString()}</td>
                                  <td>{row.lista_precios || '1'}</td>
                                  <td>
                                    <span style={{
                                      padding: '0.125rem 0.5rem',
                                      borderRadius: '0.25rem',
                                      fontSize: '0.75rem',
                                      background: row.estatus == 1 ? '#dcfce7' : '#fee2e2',
                                      color: row.estatus == 1 ? '#166534' : '#991b1b'
                                    }}>
                                      {row.estatus == 1 ? 'Activo' : 'Inactivo'}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>

                    <div className="step-actions">
                      <Button variant="secondary" onClick={() => setStepClientes(1)}>
                        Anterior
                      </Button>
                      <Button
                        variant="success"
                        onClick={ejecutarMigracionClientes}
                        disabled={loading || previewClientes.length === 0}
                      >
                        {loading ? (
                          <>
                            <RefreshCw size={16} className="spin" />
                            Migrando...
                          </>
                        ) : (
                          <>
                            <Upload size={16} />
                            Ejecutar Migracion de Clientes
                          </>
                        )}
                      </Button>
                    </div>
                  </>
                ) : (
                  <div className="migracion-resultado">
                    <div className="resultado-exito">
                      <Check size={48} />
                      <h3>Migracion de Clientes Completada</h3>
                      <div className="resultado-stats" style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
                        gap: '1rem',
                        marginTop: '1rem'
                      }}>
                        <div style={{ textAlign: 'center', padding: '0.5rem', background: '#f0fdf4', borderRadius: '0.5rem' }}>
                          <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#16a34a' }}>{clientesMigrados}</div>
                          <div style={{ fontSize: '0.75rem', color: '#15803d' }}>Clientes</div>
                        </div>
                        <div style={{ textAlign: 'center', padding: '0.5rem', background: '#eff6ff', borderRadius: '0.5rem' }}>
                          <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#2563eb' }}>{telefonosMigrados}</div>
                          <div style={{ fontSize: '0.75rem', color: '#1d4ed8' }}>Telefonos</div>
                        </div>
                        <div style={{ textAlign: 'center', padding: '0.5rem', background: '#faf5ff', borderRadius: '0.5rem' }}>
                          <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#9333ea' }}>{direccionesMigradas}</div>
                          <div style={{ fontSize: '0.75rem', color: '#7e22ce' }}>Direcciones</div>
                        </div>
                        <div style={{ textAlign: 'center', padding: '0.5rem', background: '#fef3c7', borderRadius: '0.5rem' }}>
                          <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#d97706' }}>{datosFiscalesMigrados}</div>
                          <div style={{ fontSize: '0.75rem', color: '#b45309' }}>Datos Fiscales</div>
                        </div>
                        {clientesOmitidos > 0 && (
                          <div style={{ textAlign: 'center', padding: '0.5rem', background: '#fef2f2', borderRadius: '0.5rem' }}>
                            <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#dc2626' }}>{clientesOmitidos}</div>
                            <div style={{ fontSize: '0.75rem', color: '#b91c1c' }}>Omitidos</div>
                          </div>
                        )}
                      </div>
                    </div>

                    {erroresMigracionClientes.length > 0 && (
                      <div className="errores-lista">
                        <h4><AlertCircle size={16} /> Errores durante la migracion ({erroresMigracionClientes.length})</h4>
                        <ul>
                          {erroresMigracionClientes.slice(0, 10).map((error, idx) => (
                            <li key={idx}>{error}</li>
                          ))}
                          {erroresMigracionClientes.length > 10 && (
                            <li className="more">... y {erroresMigracionClientes.length - 10} errores mas</li>
                          )}
                        </ul>
                      </div>
                    )}

                    <div className="step-actions center">
                      <Button variant="primary" onClick={reiniciarClientes}>
                        <RefreshCw size={16} />
                        Nueva Migracion
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </>
      )}

      {/* ============ TAB COSTOS ============ */}
      {activeTab === 'costos' && (
        <>
          {/* Progress Steps Costos */}
          <div className="migracion-steps">
            <div className={`step ${stepCostos >= 1 ? 'active' : ''} ${stepCostos > 1 ? 'completed' : ''}`}>
              <div className="step-number">{stepCostos > 1 ? <Check size={16} /> : '1'}</div>
              <span>Preview</span>
            </div>
            <div className="step-line" />
            <div className={`step ${stepCostos >= 2 ? 'active' : ''} ${migracionCostosCompleta ? 'completed' : ''}`}>
              <div className="step-number">{migracionCostosCompleta ? <Check size={16} /> : '2'}</div>
              <span>Actualizar</span>
            </div>
          </div>

          <div className="migracion-content">
            {/* Step 1: Info + Cargar Preview */}
            {stepCostos === 1 && (
              <div className="step-content">
                <h2><DollarSign size={20} /> Diferencia de Costos</h2>
                <p className="step-description">
                  Actualizar <strong>precio_compra</strong> y <strong>costo_precios</strong> desde la tabla <strong>diferencia_costos</strong> (BD local).
                </p>

                <div style={{
                  padding: '1rem',
                  background: '#fef3c7',
                  borderRadius: '0.5rem',
                  border: '1px solid #fcd34d',
                  marginBottom: '1rem'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                    <DollarSign size={18} color="#d97706" />
                    <strong style={{ color: '#92400e' }}>Actualización de Costos</strong>
                  </div>
                  <p style={{ margin: 0, fontSize: '0.875rem', color: '#92400e' }}>
                    Se leerá la tabla <strong>diferencia_costos</strong> de la BD local y se actualizará <strong>precio_compra</strong> y <strong>costo_precios</strong> en los productos con equivalencia (cajas).
                  </p>
                </div>

                <div className="step-actions">
                  <div />
                  <Button
                    variant="primary"
                    onClick={cargarPreviewCostos}
                    disabled={loading}
                  >
                    {loading ? <RefreshCw size={16} className="spin" /> : <Eye size={16} />}
                    Cargar Vista Previa
                  </Button>
                </div>
              </div>
            )}

            {/* Step 2: Preview y Actualización */}
            {stepCostos === 2 && (
              <div className="step-content">
                <h2><Upload size={20} /> Actualización de Costos</h2>

                {!migracionCostosCompleta ? (
                  <>
                    <div className="migracion-info" style={{ background: '#fef3c7' }}>
                      <DollarSign size={18} />
                      <span>
                        Se actualizarán costos de <strong>{totalCostos}</strong> productos desde <strong>diferencia_costos</strong>
                      </span>
                    </div>

                    {/* Estadísticas */}
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                      gap: '1rem',
                      margin: '1rem 0',
                      padding: '1rem',
                      background: '#f8fafc',
                      borderRadius: '0.5rem'
                    }}>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#d97706' }}>{totalCostos}</div>
                        <div style={{ fontSize: '0.75rem', color: '#64748b' }}>Registros en diferencia_costos</div>
                      </div>
                    </div>

                    {/* Preview colapsable */}
                    <div className="preview-section">
                      <div
                        className="preview-header"
                        onClick={() => setPreviewCostosExpandido(!previewCostosExpandido)}
                      >
                        {previewCostosExpandido ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
                        <span>Vista previa (primeros 20 registros)</span>
                      </div>

                      {previewCostosExpandido && (
                        <div className="preview-table-wrapper">
                          <table className="preview-table">
                            <thead>
                              <tr>
                                <th>ID Producto</th>
                                <th>Descripcion</th>
                                <th>Costo Calculo</th>
                                <th>Costo Pacific Soft</th>
                                <th>Costo Mayor</th>
                                <th>Diferencia</th>
                              </tr>
                            </thead>
                            <tbody>
                              {previewCostos.map((row, idx) => (
                                <tr key={idx}>
                                  <td>{row.producto_id}</td>
                                  <td>{row.descripcion?.substring(0, 35)}</td>
                                  <td>${parseFloat(row.costo_para_calculo || 0).toFixed(3)}</td>
                                  <td>${parseFloat(row.costo_pacific_soft || 0).toFixed(3)}</td>
                                  <td>${parseFloat(row.costo_mayor || 0).toFixed(3)}</td>
                                  <td style={{
                                    color: parseFloat(row.importe_diferencia || 0) > 0 ? '#16a34a' :
                                           parseFloat(row.importe_diferencia || 0) < 0 ? '#dc2626' : '#64748b'
                                  }}>
                                    ${parseFloat(row.importe_diferencia || 0).toFixed(3)}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>

                    <div className="step-actions">
                      <Button variant="secondary" onClick={() => setStepCostos(1)}>
                        Anterior
                      </Button>
                      <Button
                        variant="success"
                        onClick={ejecutarActualizacionCostos}
                        disabled={loading || previewCostos.length === 0}
                      >
                        {loading ? (
                          <>
                            <RefreshCw size={16} className="spin" />
                            Actualizando...
                          </>
                        ) : (
                          <>
                            <Upload size={16} />
                            Ejecutar Actualización de Costos
                          </>
                        )}
                      </Button>
                    </div>
                  </>
                ) : (
                  <div className="migracion-resultado">
                    <div className="resultado-exito">
                      <Check size={48} />
                      <h3>Actualización de Costos Completada</h3>
                      <div className="resultado-stats" style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
                        gap: '1rem',
                        marginTop: '1rem'
                      }}>
                        <div style={{ textAlign: 'center', padding: '0.5rem', background: '#f0fdf4', borderRadius: '0.5rem' }}>
                          <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#16a34a' }}>{costosActualizados}</div>
                          <div style={{ fontSize: '0.75rem', color: '#15803d' }}>Actualizados</div>
                        </div>
                        {costosNoEncontrados > 0 && (
                          <div style={{ textAlign: 'center', padding: '0.5rem', background: '#fef2f2', borderRadius: '0.5rem' }}>
                            <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#dc2626' }}>{costosNoEncontrados}</div>
                            <div style={{ fontSize: '0.75rem', color: '#b91c1c' }}>No encontrados</div>
                          </div>
                        )}
                      </div>
                    </div>

                    {erroresCostos.length > 0 && (
                      <div className="errores-lista">
                        <h4><AlertCircle size={16} /> Errores durante la actualización ({erroresCostos.length})</h4>
                        <ul>
                          {erroresCostos.slice(0, 10).map((error, idx) => (
                            <li key={idx}>{error}</li>
                          ))}
                          {erroresCostos.length > 10 && (
                            <li className="more">... y {erroresCostos.length - 10} errores mas</li>
                          )}
                        </ul>
                      </div>
                    )}

                    <div className="step-actions center">
                      <Button variant="primary" onClick={reiniciarCostos}>
                        <RefreshCw size={16} />
                        Nueva Actualización
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default MigracionProductosPage;
